
import { useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from 'react-router-dom';
import classes from "./RegisterUser.module.css";
import UserService from "../../Services/UserService";
import LoadingIndicator from "../CommonComponent/LoadingIndicator";
import MessagePopup from "../PopupComponent/MessagePopup";
import { ReactComponent as Error } from '../../Assets/img/Error.svg';
import { ReactComponent as Save } from '../../Assets/img/Edit-icon.svg';
import { ReactComponent as ResetIcon } from '../../Assets/img/Reset-primary-icon.svg';
import { Modal, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';

/**
 * Renders edit user pop up to edit user
 * @component
 * @param {Event} props.onClose() To close pop up
 * @param {Event} props.onShowMessage("message") To show message in pop up
 * @param {Event} props.user.username to unique identifier of users
 */
function EditUser(props) {
    //#region States 
    const [error, setError] = useState("");
    const [messagePopup, setMessagePopup] = useState(false);
    //#endregion

    //#region Refs
    const usernameInputRef = useRef();
    const emailInputRef = useRef();

    //#endregion

    //#region Edit User

    /**
    * Calls user service to edit user
    * @param  {Event} event  User action (on submitting form)
    */
    function updateHandler(event) {
        event.preventDefault();

        const enteredUsername = usernameInputRef.current.value;
        const enteredEmail = emailInputRef.current.value;

        var updateUserDTO = {
            Username: enteredUsername,
            Email: enteredEmail,
        };

        UserService.updateUserDetails(props.user.username, updateUserDTO)
            .then((response) => {
                if (response.response == null) {
                    setError(response.errors[0].message);
                    setMessagePopup(true);
                } else {
                    props.onClose();
                    props.onShowMessage("Updated sucessfully.");
                }
            })
            .catch((err) => {
                setError(err.data);
                setMessagePopup(true);
            });
    }

    //#endregion
    return (
        <Modal centered={true} contentClassName="AddDeviceMain" show={true} onHide={props.onClose}>

            <ModalHeader className="AddDeviceHeader" style={{ border: "none" }} closeButton >
                <ModalTitle className="Header">
                    <strong>Edit User</strong>
                </ModalTitle>
            </ModalHeader>

            <Modal.Body style={{ padding: '0' }}>
                {messagePopup && (
                    <div className="alert alert-warning"><Error /><span className="message-popup-title">{error}</span></div>
                )}
                <form onSubmit={updateHandler}>
                    <div style={{ padding: '3%' }}>
                        <div >
                            <label for="Username" className="label">User Name</label>
                            <input
                                className="InputField"
                                type="text"
                                defaultValue={props.user.username}
                                ref={usernameInputRef}
                                required
                            />
                        </div>
                        <br />
                        <div >
                            <label for="Email" className="label">Email</label>
                            <input className="InputField"
                                type="email"
                                defaultValue={props.user.email}
                                ref={emailInputRef}
                                required
                            />
                        </div>
                    </div>
                    <br />
                    <div>
                        <ModalFooter className="AddDeviceFooter" style={{ border: "none" }}>
                            <div>
                                <button type="reset" className="secondary-button">
                                    <span className="secondary-button-icon"><ResetIcon /></span>
                                    <span className="secondary-button-text">Reset</span>
                                </button>
                                &nbsp;
                                <button type="submit" className="primary-button ">
                                    <span className="primary-button-icon"><Save /></span>
                                    <span className="primary-button-text">Edit</span>
                                </button>

                            </div>
                        </ModalFooter>
                    </div>
                </form>
            </Modal.Body >
        </Modal >
    );
}

export default EditUser;